var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1096 8.67729C14.6682 5.69236 15.2049 3.06752 15.4058 0.97598C15.4594 0.415362 14.9703 -0.0475071 14.4006 0.0178983C12.9722 0.181771 10.4351 0.398831 8.11074 0.398831C5.78634 0.398831 3.2493 0.181771 1.82093 0.0178983C1.25046 -0.0475071 0.761386 0.415362 0.815647 0.97598C1.01656 3.06752 1.5533 5.69236 6.11191 8.67729C6.80923 9.13441 7.23598 9.9279 7.23084 10.7509C7.22864 11.1354 6.96174 11.4646 6.58265 11.5645C5.83547 11.7614 4.6982 12.1675 4.6872 12.818C4.68574 13.3081 5.80834 13.799 8.11148 13.799C10.4146 13.799 11.535 13.3081 11.5343 12.818C11.5233 12.1675 10.386 11.7614 9.63883 11.5645C9.25974 11.4646 8.99284 11.1102 8.99064 10.7257C8.98551 9.90274 9.41226 9.13441 10.1096 8.67729V8.67729ZM11.6226 5.41198C11.9694 4.03775 12.0699 2.75551 12.1 1.96418C12.1139 1.60121 12.3955 1.3015 12.7621 1.25119L13.8378 1.10456C14.0519 1.0751 14.2528 1.23897 14.2418 1.451C14.1618 3.00779 13.3025 4.67239 12.207 5.74979C11.9555 5.99703 11.5375 5.7505 11.6226 5.41198V5.41198ZM4.02761 5.74979C2.93213 4.67239 2.07277 3.00779 1.99284 1.451C1.98184 1.23897 2.18275 1.0751 2.39686 1.10456L3.47254 1.25119C3.83916 1.3015 4.12073 1.60121 4.13466 1.96418C4.16473 2.75551 4.26518 4.03775 4.61128 5.41198C4.69707 5.7505 4.27911 5.99703 4.02761 5.74979V5.74979Z",
    fill: "url(#paint0_linear_446_28087)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_446_28087",
    x1: 2.02805,
    y1: 13.799,
    x2: 15.4099,
    y2: 13.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#CAC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484848,
    stopColor: "#FFFE07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFE0B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupIcon);
export default __webpack_public_path__ + "static/media/cup-icon.616e634b1821223b94615458146b043e.svg";
export { ForwardRef as ReactComponent };